export default [
  {
    site_publisher_id: 1,
    url: "batmatic-test.ir",
    positions: [
      {
        tag_html_id: "hilite-position-1891",
        count_view_advertise_in_position_on_site_publisher_each_hour: 20,
        time_second_view_advertise_in_position_on_site_publisher: 70,
        income_each_hour: 25,
      },
      {
        tag_html_id: "hilite-position-1890",
        count_view_advertise_in_position_on_site_publisher_each_hour: 15,
        time_second_view_advertise_in_position_on_site_publisher: 90,
        income_each_hour: 40,
      },
    ],
  },
];
